<template>
<span>

  <a v-if="remark && remark.startsWith('http')" title="Open Link in New Window" target="_blank" :href="remark">

  <svg width="12px" height="12px" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
   <path d="m74.977 0.042969h-0.050781c-1.9727 0-3.5703 1.6016-3.5703 3.5703s1.5977 3.5703 3.5703 3.5703h0.054688 12.793l-58.137 58.137c-0.64844 0.64844-1.0469 1.5391-1.0469 2.5234 0 1.9727 1.6016 3.5703 3.5703 3.5703 0.98438 0 1.8789-0.39844 2.5234-1.043l58.137-58.137v12.793 0.050781c0 1.9727 1.5977 3.5703 3.5703 3.5703s3.5703-1.5977 3.5703-3.5703v-0.054687 0.003906-20.832c0.03125-0.17187 0.046874-0.375 0.046874-0.57812 0-1.9727-1.5977-3.5703-3.5703-3.5703h-0.050781-21.41zm-71.367 21.41c-1.9688 0-3.5703 1.5977-3.5703 3.5703v71.367c0 1.9727 1.6016 3.5703 3.5703 3.5703h71.367c1.9727 0 3.5703-1.5977 3.5703-3.5703v-53.844-0.050781c0-1.9727-1.5977-3.5703-3.5703-3.5703-1.9727 0-3.5703 1.5977-3.5703 3.5703v0.054687-0.003906 50.273h-64.23v-64.23h50.492 0.050781c1.9727 0 3.5703-1.5977 3.5703-3.5703 0-1.9727-1.5977-3.5703-3.5703-3.5703h-0.054688z"/>
  </svg>


  </a>


</span>
</template>

<style scoped>

  a svg{
    fill: darkgray;
    margin-left: 0.25em;
  }

  a svg:hover{
    fill: blue;
  }

</style>

<script>


export default {
  name: "EditLabelRemark",
  components: {



  },

  props: {
    remark: String,
  },

  data:function() {
    return {


    }
  },

  created: function(){



  },

};

</script>